import React from 'react';

import CommonLogo from '@/components/CommonLogo';
import Typography from '@/components/Typography';

type Props = {
  title: string;
  children: React.ReactNode;
};

const LoginHelpCommonFrame = ({ title, children }: Props): JSX.Element => {
  return (
    <div className='min-h-screen bg-gray-50 flex flex-col justify-center items-center'>
      <CommonLogo />
      <div className='bg-white py-8 px-4 sm:px-10 shadow rounded-lg flex flex-col gap-6 mt-3 sm:max-w-md w-full'>
        <Typography variant='navy700' classes={['text-center', 'font-medium']}>
          {title}
        </Typography>
        {children}
      </div>
    </div>
  );
};

export default LoginHelpCommonFrame;
